import React from 'react'
import { Breadcrumb } from '../../../components'

const HeadComponent = ({isNotExist, data}) => {
  const routes = [
    {
      name: 'Home',
      route: '/'
    },
    {
      name: 'Blog',
      route: '/blog'
    },
    {
      name: data.category,
      route: '#'
    }
  ]

  return (
    <div>
      <Breadcrumb className="mb-1 lg:mb-5" routes={routes} />
      <h1 className="text-2xl lg:text-4xl font-bold lg:leading-tight lg:mb-8 font-primary">
        {data.title}
      </h1>
      {
        isNotExist &&
        <p className="mt-3 mb-6 lg:mt-10 lg:mb-10 text-sm text-gray-444">
          • {data.date} • {data.readTime.english}
        </p>
      }
      {
        !isNotExist &&
        <p className="mt-3 mb-6 lg:mt-10 lg:mb-10 text-sm text-gray-444">
          • {data.date} • {data.readTime.bahasa}
        </p>
      }
      <hr className="lg:hidden mb-4"/>
    </div>
  )
}

export { HeadComponent }
